
import usePartakers from "@/composables/usePartakers";
import { defineComponent } from "vue";
import PageTitle from "@/components/PageTitle.vue";
import FollowFestival from "@/components/FollowFestival.vue";

export default defineComponent({
  components: {
    PageTitle,
    FollowFestival,
  },
  setup() {
    const { fetchPartakers, partakers, isFetching } = usePartakers();

    if (!partakers.value.length) {
      fetchPartakers();
    }

    return {
      partakers,
      isFetching,
    };
  },
});
